export const correlationHeader = 'X-Correlation-ID';

const fallbackId = () => {
  const random = Math.random().toString(16).slice(2);
  return `web-${Date.now().toString(16)}-${random}`.slice(0, 64);
};

export const createCorrelationId = () => (
  window.crypto?.randomUUID?.() || fallbackId()
);

export const attachCorrelationId = config => {
  const correlationId = createCorrelationId();
  config.headers = config.headers || {};
  config.headers[correlationHeader] = correlationId;
  config.correlationId = correlationId;
  return config;
};

export const captureCorrelationId = response => {
  const correlationId = response?.headers?.['x-correlation-id']
    || response?.config?.correlationId
    || null;
  if (response) response.correlationId = correlationId;
  return response;
};

export const captureCorrelationError = error => {
  error.correlationId = error?.response?.headers?.['x-correlation-id']
    || error?.config?.correlationId
    || null;
  return error;
};
